// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"320":"gaming","350":"merchant-profiler-bff","453":"market-overview","727":"merchant-command-center","779":"identity-admin"}[chunkId] + "." + {"320":"a1f5b915","350":"172d3e1d","453":"172d3e1d","727":"b7d67fd6","779":"4d48b186"}[chunkId] + ".chunk.css";
};